import { render, staticRenderFns } from "./PopupSwapRequestSuccessArea.vue?vue&type=template&id=ccd2492c"
import script from "./PopupSwapRequestSuccessArea.vue?vue&type=script&lang=js"
export * from "./PopupSwapRequestSuccessArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports